import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function MoonIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        d="M14 8.52667C13.8951 9.66147 13.4692 10.7429 12.7722 11.6445C12.0751 12.5461 11.1357 13.2305 10.0638 13.6177C8.99194 14.0049 7.83199 14.0787 6.71967 13.8307C5.60734 13.5827
        4.58866 13.023 3.78282 12.2172C2.97697 11.4113 2.41729 10.3927 2.16927 9.28033C1.92125 8.16801 1.99514 7.00806 2.38231 5.9362C2.76947 4.86434 3.45389 3.92491 4.35547
        3.22784C5.25706 2.53076 6.33853 2.10487 7.47333 2C6.80894 2.89884 6.48923 4.0063 6.57235 5.12094C6.65548 6.23559 7.13591 7.28337 7.92627 8.07373C8.71663 8.86409 9.76441
        9.34452 10.8791 9.42765C11.9937 9.51077 13.1012 9.19106 14 8.52667V8.52667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  );
}

export default MoonIcon;
